export default __webpack_public_path__ + "static/media/panel3.7b9bbf89.jpg";